/**
 * Conditional logger controlled by the Experience Config flag
 * `enable-maa-lc-console-logs`. Disabled by default.
 *
 * Usage (services / plain modules):
 *   import { logger } from '../utils/logger';
 *   logger.log('[Sprinklr] something');
 *
 * To enable from a React component/hook:
 *   import { setLoggingEnabled } from '../utils/logger';
 *   const logsEnabled = useConfigService('enable-maa-lc-console-logs');
 *   useEffect(() => { setLoggingEnabled(!!logsEnabled); }, [logsEnabled]);
 */

// This module is the single sanctioned place for console output, so the
// no-console rule is intentionally disabled here.
/* eslint-disable no-console */

let enabled = false;

export function setLoggingEnabled(flag) {
  enabled = !!flag;
}

export const logger = {
  log: (...args) => { if (enabled) console.log(...args); },
  warn: (...args) => { if (enabled) console.warn(...args); },
  error: (...args) => { if (enabled) console.error(...args); },
  info: (...args) => { if (enabled) console.info(...args); },
};
